
import initMenuState from './initMenuState';

export default function setMenu(state = initMenuState, action) {
    return state;
}
